/* unplugin-vue-components disabled */import script from "./NavTab.vue?vue&type=script&setup=true&lang=js"
export * from "./NavTab.vue?vue&type=script&setup=true&lang=js"

import "./NavTab.vue?vue&type=style&index=0&id=b8bb1c5a&lang=scss"

const __exports__ = script;

export default __exports__